module.exports = __webpack_public_path__ + "static/media/img-moduleC3.dd1d86f1.png";